import dynamic from "next/dynamic"

import type { Article } from "~/api/prismic/types"
import { SliceTypes } from "~/api/prismic/types"

import { AlertText } from "./AlertText"
import RichTextSlice from "./ArticleRichText"
import { AuthorQuote } from "./AuthorQuote"
import ChartEmbed from "./ChartEmbed"
import HighlightedQuote from "./HighlightedQuote"
import HTMLEmbed from "./HTMLEmbed"
import ImageGallery from "./ImageGallery"
import SingleImage from "./SingleImage"

const CSVTables = dynamic(
  () => import(/* webpackChunkName: "CSVTables" */ "./CSVTables"),
  { ssr: false },
)

export type ArticleSliceZoneProps = {
  slices: Article["data"]["body"]
}

const ArticleSliceZone: React.FC<ArticleSliceZoneProps> = ({ slices }) => {
  const elements = slices.map((slice, index) => {
    switch (slice.slice_type) {
      case SliceTypes.ALERT:
        return <AlertText key={index} slice={slice} />

      case SliceTypes.CHART_EMBED:
        return <ChartEmbed key={index} slice={slice} />

      case SliceTypes.CSV_TABLES:
        return <CSVTables key={index} slice={slice} />

      case SliceTypes.SINGLE_IMAGE:
        return <SingleImage key={index} slice={slice} />

      case SliceTypes.HIGHLIGHTED_QUOTE:
        return <HighlightedQuote key={index} slice={slice} />

      case SliceTypes.HTML_EMBED:
        return <HTMLEmbed key={index} slice={slice} />

      case SliceTypes.IMAGE_GALLERY:
        return <ImageGallery key={index} slice={slice} />

      case SliceTypes.QUOTE:
        return <AuthorQuote key={index} slice={slice} />

      case SliceTypes.TEXT:
        return <RichTextSlice key={index} slice={slice} />

      default:
        return null
    }
  })

  return <>{elements}</>
}

export default ArticleSliceZone
